'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectCdn = undefined;
exports.imgPreviewSettings = imgPreviewSettings;
exports.getImgSrc = getImgSrc;
exports.getImgPreviewSrc = getImgPreviewSrc;

var _capeReduxReducer = require('cape-redux-reducer');

var selectCdn = exports.selectCdn = (0, _capeReduxReducer.selectDbPath)('cdnUrl'); // @TODO getOr from db.

function imgPreviewSettings() {
  return '?crop=entropy&fit=crop&h=100&w=100';
} // Create default image url.


function getImgSrc(fileName) {
  return function (state) {
    return '' + selectCdn(state) + fileName;
  };
}

function getImgPreviewSrc(url) {
  return function (state) {
    return url + imgPreviewSettings(state);
  };
}